/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const HandlingDirection = {
    Inbound: 'Inbound',
    Outbound: 'Outbound',
    Internal: 'Internal',
    Service: 'Service',
} as const;

export type HandlingDirection = typeof HandlingDirection[keyof typeof HandlingDirection];



